import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { MusicalWorkLinkListStore } from "../../store/MusicalWorkLinkListStore";

type MusicalWorkLinkListDialogsProps = {
  store: MusicalWorkLinkListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de MusicalWorkLink.
 * Separado para mantener MusicalWorkLinkListPage más limpio.
 */
export const MusicalWorkLinkListDialogs: React.FC<MusicalWorkLinkListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
